module.exports = __webpack_public_path__ + "static/media/typeyourtitle_human.261470f6.pdf";